import { isMobile  } from '@utils/index.js'
export class Scene {
    constructor({el}) {
        this.DOM = {
            clas: el,
            el: $(el),
            tabItems: $(el).find('.tab-item'),
            tabPanes: $(el).find('.tab-pane'),
        }
        if ($(el).length > 0) {
            this.init()
        }
    }
    onEvent() {
        const that = this
        // TAb切换
        $(`${this.DOM.clas} .tab-item`).on('click', function(e) {
            const name = $(this).data('name');
            $(this).addClass('is-active');
            $(this).siblings().removeClass('is-active');

            $(`${that.DOM.clas} .tab-pane[data-name="${name}"]`).addClass('tab-pane-active')
            $(`${that.DOM.clas} .tab-pane[data-name="${name}"]`).siblings().removeClass('tab-pane-active')
            // 切换完成之后需要重新计算
            that.calcActualLines()
            const container = $(`${that.DOM.clas} .tab-contain`).get(0);
            const parentRect = container.getBoundingClientRect();
            if (isMobile()) {
                const elementRect = $(this).get(0).getBoundingClientRect()
                if (elementRect.left - parentRect.left < 0) {
                    const left = $(`${that.DOM.clas} .tab-contain`).scrollLeft() + elementRect.x - parentRect.x
                    $(`.tab-contain`).animate({
                        scrollLeft: left
                    }, 200);
                }

                if(elementRect.right - parentRect.right > 0) {
                   const left = $(`${that.DOM.clas} .tab-contain`).scrollLeft() - parentRect.right + elementRect.right
                    $(`.tab-contain`).animate({
                        scrollLeft: left
                    }, 200);
                }
                
            }
            const anchorActive = $('.sticky_anchor_active').get(0).getBoundingClientRect()
            if (parentRect.top - anchorActive.height < 2) {
                $('html, body').animate({
                    scrollTop: $('.tabs-content').offset().top - parentRect.top - anchorActive.height
                }, 200)
            }
            const gaParams = {
                module: 'Directory',
                position: $('.jky-nav-inner--container .active').text(),
                title: $('.sence-title .text').text(),
                content: $('.jky-12th-tabs .is-active').text(),
            }
            that.handleGAEvent(gaParams)

        })

        // view-more点击
        $(`${this.DOM.clas} .scene-view-more`).click(function() {
            const index = $(this).data('index')
            $(`${that.DOM.clas} .scene-text-content-${index}`).addClass('scene-expanded')
            $(this).hide()
            $(`${that.DOM.clas} .scene-view-collapse-${index}`).css({'display': 'flex'})
        })
        $(`${this.DOM.clas} .scene-view-collapse`).click(function() {
            const index = $(this).data('index')
            $(`${that.DOM.clas} .scene-text-content-${index}`).removeClass('scene-expanded')
            $(this).hide()
            $(`${that.DOM.clas} .scene-view-more-${index}`).css({'display': 'flex'})
        })

    }
    // 计算实际行数
    calcActualLines() {
        // 判断当前红人推荐文案是否超出 pc：5行 mb: 6行
        const container = document.querySelector('.tab-pane-active .scene-text-content')
        if(!container) return
        const computedStyle = window.getComputedStyle(container);
        const lineHeight = parseFloat(computedStyle.lineHeight);
        const containerHeight = parseFloat(computedStyle.height);

        // 计算最大行数
        const maxLines = Math.floor(containerHeight / lineHeight);
        
        // 计算实际行数
        const textLines = Math.floor(container.scrollHeight / lineHeight);
        if(textLines > maxLines) {
            $('.tab-pane-active .scene-view-more').css({'display': 'flex'})
            !isMobile() && $('.tab-pane-active .scene-tooltip').addClass('scene-tooltip-show')
        } else {
            $('.tab-pane-active .scene-view-more').hide()
            !isMobile() && $('.tab-pane-active .scene-tooltip').removeClass('scene-tooltip-show')
        }
    }

    // 埋码
    handleGAEvent(params) {
        // 埋码
        window.dataLayer.push({ "event_parameters": null });
        window.dataLayer.push({
            event:"ga4Event",
            event_name:"12anniversary_page_user_clicks",
            event_parameters:{
                current_page: window.location.href,
                ...params
            }
        });
    }
    init() {
        this.onEvent()
        this.calcActualLines()
    }
}